import { MrbBaseRouteStore } from "mrb/core";
import { forEach, some, every } from "lodash";
import { podcastType } from "common/constants";
import { PodcastService } from "common/services";

// A podcast reports its own flag; a group reports its sub-podcasts', which may disagree.
function resolveFemaleContent(podcast) {
    if (podcast.podcastType !== podcastType.podcastGroup) {
        return podcast.isFemale ? "Yes" : "No";
    }

    const subPodcasts = podcast.subPodcasts || [];
    if (subPodcasts.length === 0) {
        return "No";
    }
    if (every(subPodcasts, (subPodcast) => subPodcast.isFemale)) {
        return "Yes";
    }

    return some(subPodcasts, (subPodcast) => subPodcast.isFemale) ? "Mixed" : "No";
}

class PodcastListRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);

        this.service = rootStore.createApplicationService(PodcastService);
    }

    async findPodcasts(params) {
        // subPodcasts is an embed the API already supports, and it is what lets a group report
        // "Mixed" when only some of its sub-podcasts are female content.
        const response = await this.service.find({ ...params, embed: "subPodcasts" });
        const data = response.data;
        forEach(data && data.item, (podcast) => {
            podcast.femaleContent = resolveFemaleContent(podcast);
        });
        return data;
    }

    async deletePodcast(resource) {
        const response = await this.service.delete(resource);
        return response.data;
    }
}

export default PodcastListRouteStore;
